export default "__VITE_ASSET__DQ4wbL60__"